import Vue from 'vue'
import Vuex from 'vuex'
import config from "./stores/config"

Vue.use(Vuex)

const store= new Vuex.Store({
  modules:{
    config
  },
  state: {

  },
  mutations: {

  },
  actions: {

  }
});


export default store;
